import withStyles from '@mui/styles/withStyles';
import Button from '@mui/material/Button';
import { IconDownload } from '@experimental-components/IconsComponents/Download';

const ButtonCloudBase = withStyles((theme) => ({
  root: {
    backgroundColor: (props) => (props.variant === 'black' ? theme.palette.common.black : theme.palette.darkGrey[2]),
    color: (props) => (props.variant === 'black' ? theme.palette.common.white : theme.palette.common.black),

    '&:hover': {
      backgroundColor: (props) => (props.variant === 'black' ? theme.palette.common.black : theme.palette.darkGrey[5]),
      boxShadow: 'none',
    },

    '&:active': {
      boxShadow: 'none',
      backgroundColor: (props) => (props.variant === 'black' ? theme.palette.common.black : theme.palette.darkGrey[2]),
    },

    '&$disabled': {
      color: (props) => (props.variant === 'black' ? theme.palette.darkGrey[50] : theme.palette.darkGrey[50]),
    },
  },

  disabled: {
    backgroundColor: (props) =>
      props.variant === 'black' ? theme.palette.common.black : theme.palette.action.disabledBackground,
    color: (props) => (props.variant === 'black' ? theme.palette.common.white : theme.palette.darkGrey[50]),
  },

  sizeSmall: {
    padding: 16,
  },
  startIcon: {
    margin: 0,
    paddingRight: (props) => (props.children ? 8 : 0),
  },
}))(Button);

export const ButtonDownload = ({ disabled = false, isDisabled = false, variant = 'default', ...others }) => {
  return (
    <ButtonCloudBase
      disableElevation
      disableRipple
      disabled={disabled || isDisabled}
      startIcon={<IconDownload size={16} />}
      variant={variant}
      {...others}
    />
  );
};
